module.exports = __webpack_public_path__ + "img/osi-logo.8972d122.svg";